import { render, staticRenderFns } from "./qdQuickBasicInformation.vue?vue&type=template&id=331faa92&scoped=true"
import script from "./qdQuickBasicInformation.vue?vue&type=script&lang=js"
export * from "./qdQuickBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./qdQuickBasicInformation.vue?vue&type=style&index=0&id=331faa92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331faa92",
  null
  
)

export default component.exports